module.exports = __webpack_public_path__ + "static/media/gobackblue.27bbfcef.svg";